/* ******************** ↓ STAFF CARD/MODAL LINKS ↓ ******************** */
// [[./staff-card.js]]
// [[../pages/about.js]]
/* ******************** ↑ STAFF CARD/MODAL LINKS ↑ ******************** */
export const staff = [
    // Dr. Mikki Allen
    {
        id: "mikkiAllen",
        image: "assets/media/pages/about/team/dr-allen-sm.jpg",
        name: "Dr. Mikki Allen",
        title: "Director of Athletics",
    },
    // Dusty Bennett
    {
        id: "dustyBennett",
        image: "assets/media/pages/about/team/dusty-2025.jpg",
        name: "Dusty Bennett",
        title: "Executive AD for Administration and Capital Projects",
    },

    // Julius McNair
    {
        id: "juliusMcnair",
        image: "assets/media/pages/about/team/julius-mcnair.jpg",
        name: "Julius McNair",
        title: "Assistant AD of Administration and Strategic Partnerships",
    },
];
